import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Button,
  Row,
  Col,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
// import GameListHome from "../InPlays/Sports";
import GamesListing from "../InPlays/GamesListing";
import notify from "../../components/notifier";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import User from "../../services/user";
import { useCookies } from "react-cookie";
import "./HeroSection.css";
import LiveCasinoList from "./LiveCasinoList";
import PartnerList from "./PartnerList";
import user from "../../services/user";
import MEDIA_URL from "../../contants";


const Sidebar = (props) => {
  const [activeTab, setactiveTab] = useState("2");
  const [screenSize, setScreenSize] = useState("");
  const [darkMode, setDarkMode] = useState(true);
  const [IdmodalView, setIdmodalView] = useState(false);
  const [DepositmodalView, setDepositmodalView] = useState(false);
  const [WithdrawlmodalView, setWithdrawlmodalView] = useState(false);
  const [ChangePasswordmodalView, setChangePasswordmodalView] = useState(false);
  const [Amount, setAmount] = useState(0);
  const [AmountError, setAmountError] = useState("");
  const [isDepositSubmit, setisDepositSubmit] = useState(false);
  const [isWithdrawlSubmit, setisWithdrawlSubmit] = useState(false);
  const [showDetailModal, setshowDetailModal] = useState(false);
  const [userDetails, setuserDetails] = useState("");
  const [selPortal, setselPortal] = useState("");
  const [createuser, setcreateuser] = useState("");
  const [isAvailable, setisAvailable] = useState(true);
  const [open, setOpen] = useState("collapseOne");
  const [tabGameTypeTenis, settabGameTypeTenis] = useState("TNNS");
  const [tabGameTypeSoccer, settabGameTypeSoccer] = useState("Soccer");
  const [portalList, setportalList] = useState([]);
  const [clientPortalList, setclientPortalList] = useState([]);
  const [instagram, setInstagram] = useState(null);
  const [facebook, setFacebook] = useState(null);
  const [telegram, setTelegram] = useState(null);
  const [webSlides, setwebSlides] = useState([]);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [PasswordError, setPasswordError] = useState({
    NewPasswordError: "",
    ConfirmPasswordError: "",
  });
  const [isSubmitChangePassword, setisSubmitChangePassword] = useState(false);
  const [showPromotion, setShowPromotion] = useState(
    props && props.showPromotion ? props.showPromotion : false
  );
  const notifyUser = () => {
    notify("Please Login to Batman247 first", "error", "top-right");
  };

  const [tabGameType, setTabGameType] = useState("CRCKT");

  const menuChanged = (gameType) => {
    setTabGameType(gameType);
  };

  const clientInformation = JSON.parse(localStorage.getItem("loginUserInfo"));
  // console.log('clientInformation',clientInformation)
  const redirect = (link, validate) => {
    props.history.push(link);
  };
  const SearchUserName = (username) => {};
  const togglemodal = () => {
    localStorage.setItem("welcomemsg", true);
    setmodalView(!modalView);
  };
  const SelectPortal = (status, portal) => {
    setIdmodalView(status);
    setselPortal(portal);
  };
  const toggleIdmodal = () => {
    setIdmodalView(!IdmodalView);
    setuserDetails("");
    setselPortal("");
  };
  const toggleDepositmodalView = () => {
    setDepositmodalView(!DepositmodalView);
  };
  const toggleWithdrawlmodalView = () => {
    setWithdrawlmodalView(!WithdrawlmodalView);
  };
  const toggleChangePasswordmodalView = () => {
    setChangePasswordmodalView(!ChangePasswordmodalView);
  };
  const toggleshowDetailModal = () => {
    setshowDetailModal(!showDetailModal);
  };
  const handleSignupChange = (e) => {
    console.log(e);
  };
  let availablebalanceamount = 0;
  let totalExposure = 0;
  let balancemount = 0;
  let username = "";
  props.user &&
    props.user.GamewiseExposure &&
    props.user.GamewiseExposure.forEach((expo) => {
      totalExposure += expo.UsedExposure;
    });

  if (props.user && props.user.BalanceAmount) {
    balancemount = props.user.BalanceAmount;
  }
  if (balancemount >= 1) {
    availablebalanceamount = balancemount - totalExposure;
  }
  if (props.user && props.user.ClientName) {
    username = props.user.ClientName;
  }
  const [modalView, setmodalView] = useState(false);

  const [gameActive, setGameActive] = useState("All");
  const showEvolution = (data) => {
    let gameCode = "";
    const userToken = JSON.parse(localStorage.getItem("@access:token"));
    if (!userToken) {
      notify("Please Login first", "error", "top-right");
      return false;
    }
    if (data === "ezugi") {
      gameCode = "EZUGI-Lottery_602000";
    } else if (data === "evolution") {
      gameCode = "EVOLUTION-baccarat-lobby";
    } else if (data === "vivo") {
      gameCode = "VIVO-lobby-0";
    } else if (data === "tvbet") {
      gameCode = "TVBET-lobby";
    } else if (data === "7mojos") {
      const urlTv = window.location.origin + "/MojosList";
      window.open(urlTv, "_self");
      return;
    } else if (data === "onetouch") {
      gameCode = "OT-607d38017d98a608f18de3ac";
    } else if (data === "superspadegames") {
      gameCode = "SSG-Lobby";
    } else if (data === "AndarBahar") {
      const url = window.location.origin + "/Casino/EZ/228000";
      window.open(url, "_self");
      return;
    } else if (data === "PokerBet") {
      const url = window.location.origin + "/Casino/EZ/507000";
      window.open(url, "_self");
      return;
    } else if (data === "TeenPatti") {
      const url = window.location.origin + "/Casino/EZ/227103";
      window.open(url, "_self");
      return;
    } else if (data === "7UpDown") {
      const url = window.location.origin + "/Casino/EZ/228001";
      window.open(url, "_self");
      return;
    } else if (data === "EZUGI-BaccaratDragonTiger_150") {
      const url = window.location.origin + "/Casino/EZ/150";
      window.open(url, "_self");
      return;
    } else if (data === "Roulette") {
      const url = window.location.origin + "/Casino/EZ/221005";
      window.open(url, "_self");
      return;
    } else if (data === "Baccarot") {
      const url = window.location.origin + "/Casino/SN/BAC";
      window.open(url, "_self");
      return;
    }

    const url = window.location.origin + "/CasinoDetail/" + gameCode;
    // console.log("DATA =====", data, url);
    window.open(url, "_self");
  };

  const showSupernowa = (data) => {
    const userToken = JSON.parse(localStorage.getItem("@access:token"));
    if (!userToken) {
      notify("Please Login first", "error", "top-right");
      return false;
    }
    // setGameActive(data);
    const url = window.location.origin + "/Casino";
    window.open(url, "_self");
  };

  const showCasinoGame = (data) => {
    // console.log("rajeev data casino", data);
    setGameActive(data);
  };

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      let newSize = "";

      if (width < 768) {
        newSize = "Small";
      }

      setScreenSize(newSize);
    }

    // Listen for resize events
    window.addEventListener("resize", handleResize);

    // Initial call to set screen size
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (clientInformation) {
      Portals();
    }

    if (props.banners) {
      setwebSlides(props.banners);
    }
  }, []);
  useEffect(() => {
    if (props.banners) {
      setwebSlides(props.banners);
    }
  }, [props.banners]);
  const Portals = () => {
    // User.UserPortalList()
    //   .then((res) => {
    //     if (res) {
    //       setclientPortalList(res.data.data)
    //       // console.log('res.data.data',res.data.data)
    //     }
    //   })
    //   .catch((err) => {
    //     if (err.response.status === 400) {
    //       notify(err.response.data, "error", "top-left");
    //     }
    //   });
  };
  const depositC = (portal) => {
    setselPortal(portal);
    setDepositmodalView(true);
  };
  const withdrawlC = (portal) => {
    setselPortal(portal);
    setWithdrawlmodalView(true);
  };
  const changePasswordC = (portal) => {
    setselPortal(portal);
    setChangePasswordmodalView(true);
  };
  const depositAmount = () => {
    setisDepositSubmit(true);
    if (Amount == 0 || Amount < 0) {
      setAmountError("Please enter valid amount.");
      setisDepositSubmit(false);
      return;
    }
    if (!selPortal) {
      setAmountError("Error please try again later.");
      setisDepositSubmit(false);
      return;
    }
    setAmountError("");
    let data = {};
    data.portalid = selPortal && selPortal.Portal && selPortal.Portal._id;
    data.ClientName = selPortal && selPortal.ClientName;
    data._id = selPortal && selPortal._id;
    data.amount = Amount;
    User.userDepositTransfer(data)
      .then((response) => {
        setisDepositSubmit(false);
        setselPortal("");
        setAmount("");
        Portals();
        toggleDepositmodalView();
        notify("Deposit Successfully", "success", "top-right");
      })
      .catch((error) => {
        console.log("response", error.response);
        if (error.response.status === 400) {
          setisDepositSubmit(false);
          notify(error.response.data.message, "error", "top-right");
        }
      });
  };
  const withdrawalAmount = () => {
    setisWithdrawlSubmit(true);
    if (Amount == 0 || Amount < 0) {
      setAmountError("Please enter valid amount.");
      setisWithdrawlSubmit(false);
      return;
    }
    if (!selPortal) {
      setAmountError("Error please try again later.");
      setisWithdrawlSubmit(false);
      return;
    }
    setAmountError("");
    let data = {};
    data.portalid = selPortal && selPortal.Portal && selPortal.Portal._id;
    data.ClientName = selPortal && selPortal.ClientName;
    data._id = selPortal && selPortal._id;
    data.amount = Amount;
    // data.portal = selPortal;
    User.userWithdrawlTransfer(data)
      .then((response) => {
        setselPortal("");
        setAmount("");
        Portals();
        setisWithdrawlSubmit(false);
        toggleWithdrawlmodalView();
        notify("Withdrawal Successfully", "success", "top-right");
      })
      .catch((error) => {
        console.log("response", error.response);
        if (error.response.status === 400) {
          setisWithdrawlSubmit(false);
          notify(error.response.data.message, "error", "top-right");
          // console.log('error msg user availablifi', error.response.data);
        }
      });
  };
  const settNewPassword = (e) => {
    setNewPassword(e.target.value);
  };

  const settConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const logoutHandler = (e) => {
    user
      .userLogoutStatus()
      .then((res) => {
        // console.log("logoutHnadler=", res.data);
        if (res.data.data.LogedIn === 0) {
          localStorage.clear();
          // this.props.history.replace("/");
          window.location.reload();
          console.log("Logout successfully");
        }
      })
      .catch((err) => console.log(err.message));
  };

  const validatePassword = () => {
    let regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    // console.log(NewPassword);
    // if(NewPassword == '' || !NewPassword || NewPassword.match(regex)){
    if (NewPassword == "" || !NewPassword || NewPassword.length < 8) {
      // setPasswordError({NewPasswordError: 'Minimum 8 letter password, with at least a special character, upper and lower case letters and a number'})
      setPasswordError({ NewPasswordError: "Minimum 8 letter password." });
      return;
    }
    // if(ConfirmPassword == '' || !ConfirmPassword || ConfirmPassword.match(regex)){
    if (
      ConfirmPassword == "" ||
      !ConfirmPassword ||
      ConfirmPassword.length < 8
    ) {
      // setPasswordError({ConfirmPasswordError: 'Minimum 8 letter password, with at least a special character, upper and lower case letters and a number'})
      setPasswordError({ ConfirmPasswordError: "Minimum 8 letter password." });
      return;
    }
    // console.log('NewPassword', NewPassword)
    // console.log('ConfirmPassword', ConfirmPassword)
    if (NewPassword !== ConfirmPassword) {
      setPasswordError({
        ConfirmPasswordError: "Confirm password not same as new password",
      });
      return;
    }
    setPasswordError({ NewPasswordError: "", ConfirmPasswordError: "" });
    return true;
  };

  const ChangePassword = () => {
    setisSubmitChangePassword(true);
    if (!validatePassword()) {
      setisSubmitChangePassword(false);
      return;
    }
    let data = {};
    data.Password = NewPassword;
    data.PortalName = selPortal && selPortal.PortalName;
    data.user_id = selPortal._id;
    User.userChangePassword(data)
      .then((response) => {
        setisSubmitChangePassword(false);
        setChangePasswordmodalView(false);
        notify("Password changed successfully", "success", "top-right");
        setNewPassword("");
        setConfirmPassword("");
      })
      .catch((error) => {
        if (error.response.status === 400) {
          setChangePasswordmodalView(false);
          setisSubmitChangePassword(false);
          console.log("error msg user availablifi", error.response.data);
        }
      });
  };

  const CheckUser = (e) => {
    setcreateuser(e.target.value);
    setisAvailable(true);
    let ClientName = e.target.value;
    // let Portal = selPortal.PortalName;
    if (e.target.value) {
      if (ClientName && ClientName.length > 3) {
        User.checkClientNameAvailibilty({ ClientName })
          .then((response) => {
            setisAvailable(true);
          })
          .catch((error) => {
            if (error.response.status === 400) {
              setisAvailable(false);
              console.log("error msg user availablifi", error.response.data);
            }
          });
      }
    }
  };

  const sportsbookredirect = (item) => {
    const userToken = JSON.parse(localStorage.getItem("@access:token"));
    if (!userToken) {
      notify("Please Login first", "error", "top-right");
      return false;
    }
    let url = "";
    if (item == "sportsbook") {
      url = window.location.origin + "/sports-book/BT/no";
    } else if (item == "casino") {
      url = window.location.origin + "/Casino/GT/no";
    } else if (item == "virtualsports") {
      url = window.location.origin + "/virtual-sports/BR/no";
    } else {
      return;
    }

    window.open(url, "_self");
    return;
  };
  const createPortalUserId = () => {
    let username = createuser;
    let PortalName = selPortal && selPortal.PortalName;
    let Portal = selPortal && selPortal._id;
    User.createPortalUser({ username, PortalName, Portal })
      .then((response) => {
        notify("Id Created successfully", "success", "top-right");
        setuserDetails(response.data.data);
        Portals();
      })
      .catch((error) => {
        if (error.response.status === 400) {
          console.log("error msg user availablifi", error.response.data);
        }
      });
  };
  const clipBoard = (txt) => {
    navigator.clipboard.writeText(txt);
    notify("Text copied", "success", "top-left");
  };
  const clientInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

  const options = {
    responsiveClass: true,
    dots: true,
    autoplay: true,
    loop: true,
    center: true,

    responsive: {
      0: {
        items: 1,
        // stagePadding: 35,
        // margin: 15,
        margin: 20,
        nav: false,
        center: true,
      },
      600: {
        items: 1,
        nav: false,
      },
      1024: {
        items: 3,
        nav: false,
      },
      1366: {
        items: 3,
      },
    },
  };
  const showPage = () => {
    if (!clientInfo) {
      notify("First log in to Deposit/Withdraw Money", "error", "top-right");
    }
  };
  let portalids = clientPortalList.map(
    (portal) => portal.PortalId && portal.PortalId._id
  );

  const clientName = clientInformation
    ? clientInformation.user.ClientName[0].toUpperCase()
    : "";

  useEffect(() => {
    if (props && props.settings && props.settings.length > 0) {
      let webSettingsInfo = props.settings;
      const instagramLink =
        webSettingsInfo.find(
          (item) => item.Name === "instagram" && item.url != ""
        )?.url || null;
      setInstagram(instagramLink);
      const facebookLink =
        webSettingsInfo.find(
          (item) => item.Name === "facebook" && item.url != ""
        )?.url || null;
      setFacebook(facebookLink);
      const telegramLink =
        webSettingsInfo.find(
          (item) => item.Name === "telegram" && item.url != ""
        )?.url || null;
      setTelegram(telegramLink);
    }
  }, [props && props.settings]);
  return (
    <>
      <React.Fragment>
        <div className="container">
          <div className="row side-mob-menu">
            {showPromotion && (
              <div className="col-12">
                <div className="promotion-text">PROMOTION</div>
                <img
                  className="promotion-img"
                  src={`${MEDIA_URL}/web-images/promotion2.png`}
                  alt=""
                />
              </div>
            )}
            <div className="col-12">
              {clientInformation && (
                <div className="prof-user">
                  <a href="/profile">
                    <div className="prof-name">
                      {clientName ? clientName : ""}
                    </div>
                  </a>
                  <span className="prof-bg-color">
                    {clientInformation ? clientInformation.user.ClientName : ""}
                  </span>
                </div>
              )}
            </div>
            <div className="col-12 p-0 mb-3">
              <span className="heading-side">SPORTS</span>
            </div>
            <div className="col-12">
              <div className="accordion" id="sidebar-option">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingEight">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseEight"
                      aria-expanded="false"
                      aria-controls="collapseEight"
                    >
                      <img
                        src={`${MEDIA_URL}/web-images/game_cricket.png`}
                        alt=""
                        className="btn-img"
                      />
                      Cricket
                    </button>
                  </h2>
                  <div
                    id="collapseEight"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingEight"
                    data-bs-parent="#sidebar-option"
                  >
                    <div className="accordion-body">
                      <GamesListing
                        gameType={tabGameType ? tabGameType : "CRCKT"}
                        heading={false}
                        noshow={true}
                        parentprops={props}
                        origin={"home-origin"}
                        cricketMatches={
                          props && props.cricketMatches && props.cricketMatches
                        }
                        onlyList={true}
                        showHideSideBar={props && props.handleClick}
                      />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingNine">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseNine"
                      aria-expanded="false"
                      aria-controls="collapseNine"
                    >
                      <img
                        src={`${MEDIA_URL}/web-images/soccer_img.png`}
                        alt=""
                        className="btn-img"
                      />
                      Soccer
                    </button>
                  </h2>
                  <div
                    id="collapseNine"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingNine"
                    data-bs-parent="#sidebar-option"
                  >
                    <div className="accordion-body">
                      <GamesListing
                        gameType={"Soccer"}
                        heading={false}
                        noshow={true}
                        parentprops={props}
                        origin={"home-origin"}
                        soccerMatches={
                          props && props.soccerMatches && props.soccerMatches
                        }
                        onlyList={true}
                        showHideSideBar={props && props.handleClick}
                      />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTen">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTen"
                      aria-expanded="false"
                      aria-controls="collapseTen"
                    >
                      <img
                        src={`${MEDIA_URL}/web-images/tennis-img.png`}
                        alt=""
                        className="btn-img"
                      />
                      Tennis
                    </button>
                  </h2>
                  <div
                    id="collapseTen"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTen"
                    data-bs-parent="#sidebar-option"
                  >
                    <div className="accordion-body">
                      <GamesListing
                        gameType={"TNNS"}
                        heading={false}
                        noshow={true}
                        parentprops={props}
                        origin={"home-origin"}
                        tennisMatches={
                          props && props.tennisMatches && props.tennisMatches
                        }
                        onlyList={true}
                        showHideSideBar={props && props.handleClick}
                      />
                      {/* <GameListHome
                        onlyList={true}
                        gameType={"TNNS"}
                        heading={false}
                        noshow={true}
                        parentprops={props}
                        showHideSideBar={props && props.handleClick}
                        origin={"home-origin"}
                      /> */}
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingEleven">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseEleven"
                      aria-expanded="false"
                      aria-controls="collapseEleven"
                    >
                      <img
                        src={`${MEDIA_URL}/web-images/basketbal_img.png`}
                        alt=""
                        className="btn-img"
                      />
                      E-Games
                    </button>
                  </h2>
                  <div
                    id="collapseEleven"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingEleven"
                    data-bs-parent="#sidebar-option"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>No Game found</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 p-0 mt-2 mb-3">
              <span className="heading-side">CASINO</span>
            </div>
            <div className="col-12 gap-2">
              <button
                type="button"
                onClick={() =>
                  clientInformation
                    ? showEvolution(`AndarBahar`)
                    : notify("Please login to Continue", "error", "top-left")
                }
                className="depoists-btn"
              >
                <img
                  src={`${MEDIA_URL}/web-images/depoist.png`}
                  alt=""
                  className="images_multiple"
                />
                Andar Bahar
              </button>
            </div>
            <div className="col-12 gap-2">
              <button
                type="button"
                onClick={() =>
                  clientInformation
                    ? showEvolution(`TeenPatti`)
                    : notify("Please login to Continue", "error", "top-left")
                }
                className="depoists-btn"
              >
                <img
                  src={`${MEDIA_URL}/web-images/coupons.png`}
                  alt=""
                  className="images_multiple"
                />
                Teen Patti
              </button>
            </div>
            <div className="col-12 gap-2">
              <button
                type="button"
                onClick={() =>
                  clientInformation
                    ? showEvolution(`PokerBet`)
                    : notify("Please login to Continue", "error", "top-left")
                }
                className="depoists-btn"
              >
                <img
                  src={`${MEDIA_URL}/web-images/transaction.png`}
                  alt=""
                  className="images_multiple"
                />
                Poker
              </button>
            </div>
            <div className="col-12 gap-2">
              <button
                type="button"
                onClick={() =>
                  clientInformation
                    ? showEvolution(`EZUGI-BaccaratDragonTiger_150`)
                    : notify("Please login to Continue", "error", "top-left")
                }
                className="depoists-btn"
              >
                <img
                  src={`${MEDIA_URL}/web-images/transaction.png`}
                  alt=""
                  className="images_multiple"
                />
                Dragon Tiger
              </button>
            </div>
            <div className="col-12 gap-2">
              <button
                type="button"
                onClick={() =>
                  clientInformation
                    ? showEvolution(`7UpDown`)
                    : notify("Please login to Continue", "error", "top-left")
                }
                className="depoists-btn"
              >
                <img
                  src={`${MEDIA_URL}/web-images/transaction.png`}
                  alt=""
                  className="images_multiple"
                />
                Lucky 7
              </button>
            </div>
            <div className="col-12 gap-2">
              <button
                type="button"
                onClick={() =>
                  clientInformation
                    ? showEvolution(`Roulette`)
                    : notify("Please login to Continue", "error", "top-left")
                }
                className="depoists-btn"
              >
                <img
                  src={`${MEDIA_URL}/web-images/transaction.png`}
                  alt=""
                  className="images_multiple"
                />
                Roulette
              </button>
            </div>
            <div className="col-12 gap-2">
              <button
                type="button"
                onClick={() =>
                  clientInformation
                    ? showEvolution(`Baccarot`)
                    : notify("Please login to Continue", "error", "top-left")
                }
                className="depoists-btn"
              >
                <img
                  src={`${MEDIA_URL}/web-images/transaction.png`}
                  alt=""
                  className="images_multiple"
                />
                Baccarat
              </button>
            </div>
            <div className="row my-2 mx-0">
              <div className="col-12 bold-hr">
                <hr />
              </div>
            </div>
            <div className="d-grid gap-2 col-12 mx-auto live_chat">
              {instagram ? (
                <button className="whatsapp" type="button">
                  <img
                    src={`${MEDIA_URL}/web-images/social-links/instagram.png`}
                    alt=""
                    className="soc-img"
                  />
                  <a className="soc-color" href={instagram}>
                    INSTAGRAM
                  </a>
                </button>
              ) : null}
              {telegram ? (
                <button className="whatsapp" type="button">
                  <img
                    src={`${MEDIA_URL}/web-images/social-links/telegram.png`}
                    alt=""
                    className="soc-img"
                  />
                  <a className="soc-color" href={telegram}>
                    TELEGRAM
                  </a>
                </button>
              ) : null}
              {facebook ? (
                <button className="whatsapp" type="button">
                  <img
                    src={`${MEDIA_URL}/web-images/social-links/facebook.png`}
                    alt=""
                    className="soc-img"
                  />
                  <a className="soc-color" href={facebook}>
                    FACEBOOK
                  </a>
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </React.Fragment>
    </>
  );
};

export default Sidebar;
